/* eslint-disable @typescript-eslint/ban-ts-comment */
import { defineCustomElement } from "vue";
import BehindJump from "./behindJump.ce.vue";

// @ts-ignore
const CustomElement = defineCustomElement(BehindJump);

// type CustomComponents = {
//   [key: string]: {
//     name: string
//     type: 'inline' | 'block'
//     nestable: boolean
//     props?: {
//       [key: string]: string
//     }
//     Constructor: CustomElementConstructor
//   }
// }

export function behindJumpRegister(tagName: string = "behind-jump") {
  customElements.define(tagName, CustomElement);
  return CustomElement;
}
